var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stats_large",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11091",
    "data-name": "Rectangle 11091",
    width: 65,
    height: 65,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4457",
    "data-name": "Group 4457",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46174",
    "data-name": "Path 46174",
    d: "M15.725,62H5.05A3.179,3.179,0,0,1,2,58.722V25.944a3.179,3.179,0,0,1,3.05-3.278H15.725a3.179,3.179,0,0,1,3.05,3.278V58.722A3.179,3.179,0,0,1,15.725,62ZM37.838,3H27.162a3.179,3.179,0,0,0-3.05,3.278V58.722A3.179,3.179,0,0,0,27.162,62H37.838a3.179,3.179,0,0,0,3.05-3.278V6.278A3.179,3.179,0,0,0,37.838,3ZM59.95,29.222H49.275a3.179,3.179,0,0,0-3.05,3.278V58.722A3.179,3.179,0,0,0,49.275,62H59.95A3.179,3.179,0,0,0,63,58.722V32.5A3.179,3.179,0,0,0,59.95,29.222Z",
    transform: "translate(-2 -3)",
    fill: "#374955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsLarge);
export default __webpack_public_path__ + "static/media/stats_large.4c2a0b0863b941cac66f7ec907e81a15.svg";
export { ForwardRef as ReactComponent };